



















import {Component, Mixins} from 'vue-property-decorator';
import DialogEventsMixin from '@/components/dialog/DialogEventsMixin';
import DefaultFormMixin from '@/views/DefaultFormMixin';
import CommonPromptDialog from '@/components/dialog/CommonPromptDialog.vue';
import {CodeRetrieveResponse, CommonReasonDialogRequest, SyncOption} from '@/model/CommonModel';
import CommonButton from '@/components/button/CommonButton.vue';
import TextInput from '@/components/input/TextInput.vue';
import RadioInput from '@/components/input/RadioInput.vue';

@Component({
  components: {RadioInput, TextInput, CommonButton, CommonPromptDialog},
  mixins: [DialogEventsMixin, DefaultFormMixin]
})
export default class SyncOptionsDialog extends Mixins(DialogEventsMixin, DefaultFormMixin) {
  private dialogVisible = false;
  private onConfirm: any;
  private option: SyncOption = 'ADVERSE_EVENT';

  private syncOptions: CodeRetrieveResponse[] = [
    {
      codeLabel: 'Adverse Event',
      codeValue: 'ADVERSE_EVENT',
    }, {
      codeLabel: 'Subject',
      codeValue: 'SUBJECT',
    }
  ];


  get isVisible() {
    return this.dialogVisible;
  }

  get getSyncType() {
    return this.option;
  }


  public hide() {
    this.dialogVisible = false;
  }

  public beforeApiCall() {
    this.loading = true;
  }

  public afterApiCall() {
    this.loading = false;
  }


  public mounted() {
    this.loading = false;
    this.$modal
        .getEventBus()
        .$on('showSyncOptionsDialog', (params: CommonReasonDialogRequest) => {
          this.option = 'ADVERSE_EVENT';
          this.show(params);
        });

    this.$modal.getEventBus().$on('hideSyncOptionsDialog', () => this.cancel());
  }

  public show(params: CommonReasonDialogRequest) {
    const {onConfirm} = params;
    this.onConfirm = onConfirm;
    this.dialogVisible = true;
    this.loading = false;
  }

  public confirm() {
    if (this.isLoading) {
      return;
    }
    this.submit();
  }

  private submit() {
    this.loading = true;
    if (typeof this.onConfirm === 'function') {
      this.onConfirm(this);
    } else {
      this.dialogVisible = false;
    }
  }

  public cancel() {
    this.dialogVisible = false;
    this.loading = false;
  }
}
